var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5098 12.4609L13.4839 10.827C13.0189 10.4602 12.3547 10.4268 11.8897 10.7936L10.1627 12.0608C9.96347 12.2275 9.66457 12.1941 9.4653 11.9941L6.87479 9.65986L4.54998 7.05887C4.35072 6.8588 4.35072 6.59203 4.48356 6.35861L5.7456 4.62462C6.11093 4.15778 6.07772 3.49086 5.71239 3.02401L4.08502 0.989913C3.58685 0.389686 2.69014 0.322994 2.12554 0.889875L0.398539 2.62386C0.132846 2.89063 0 3.25744 0 3.62424C0.166058 7.02553 1.69379 10.2601 3.95218 12.5276C6.21056 14.7951 9.43209 16.329 12.8197 16.4958C13.185 16.5291 13.5503 16.3624 13.816 16.0956L15.543 14.3616C16.174 13.8614 16.1408 12.9278 15.5098 12.4609Z","fill":"#151515"}));
}

Phone.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"currentColor"};

module.exports = Phone;

Phone.default = Phone;
